module.exports = __webpack_public_path__ + "static/media/laptop.ab674d52.png";